import { render, staticRenderFns } from "./DetachMenu.vue?vue&type=template&id=2e916fdc&scoped=true"
import script from "./DetachMenu.vue?vue&type=script&lang=js"
export * from "./DetachMenu.vue?vue&type=script&lang=js"
import style0 from "./DetachMenu.vue?vue&type=style&index=0&id=2e916fdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e916fdc",
  null
  
)

export default component.exports